import React from 'react';
import { Banner } from '@shopify/polaris';
import './style.css'

const WarningCard = props => {
    return (
        <div style={{ width: props.width, margin: props.margin }}>
            <Banner
                title={props.title}
                tone={props.status}
            >
                <div>{props.message}</div>
                {
                    props.action
                    &&
                    <a
                        className="action"
                        onClick={props.onclick && props.onclick}
                        href={props.actionLink && props.actionLink}
                        target={props.target && props.target}
                    >
                        {props.actionText && props.actionText}
                    </a>
                }
            </Banner>
        </div >
    )
}


export default WarningCard;